import React from 'react';
import classNames from 'classnames';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import { SectionPaddingVertical, SectionWidth } from '../../../../components/global/Layout';

import styles from './PlanSelectorRedesign.module.css';
import SubscriptionPlan from './SubscriptionPlanRedesign';

function ValueProps({ valueProps }) {
  return (
    <div
      className={classNames(
        styles.planSelectorColumn,
        styles.planSelectorColumnSizing,
        styles.planSelectorValueProps
      )}
    >
      {valueProps.map(({ text, subnote }, i) => (
        <div key={`plan_selector_valueprop_${i}`} className={styles.valuePropContainer}>
          <CodeSparkThemedTypography variant="subtitle1" className={styles.valuePropText}>
            {text}
          </CodeSparkThemedTypography>
          {subnote && (
            <CodeSparkThemedTypography variant="body3" className={styles.valuePropSubnote}>
              {subnote}
            </CodeSparkThemedTypography>
          )}
        </div>
      ))}
    </div>
  );
}

function PlanSelectorRedesign({
  title,
  valueProps,
  planOptionsData,
  onCtaClick,
  ctaLabel,
}) {
  const valuePropKeys = valueProps.map(({ key }) => key);
  return (
    <SectionWidth className={styles.planSelectorSection}>
      <SectionPaddingVertical>
        <CodeSparkThemedTypography variant="h2" align="center">
          {title}
        </CodeSparkThemedTypography>

        <div className={styles.planSelectorPlanOptions}>
          <ValueProps valueProps={valueProps} />

          {planOptionsData.map(planData => {
            return (
              <SubscriptionPlan
                key={planData.plan.planId}
                valuePropKeys={valuePropKeys}
                onCtaClick={onCtaClick}
                ctaLabel={ctaLabel}
                {...planData}
              />
            );
          })}
        </div>
      </SectionPaddingVertical>
    </SectionWidth>
  );
}

export default PlanSelectorRedesign;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/PaymentModule/PlanSelectorRedesign.js